import React, { useEffect } from 'react';

import {
  ModalDisclaimer,
  ModalDisclaimersService,
} from '@vw-marketing/us-components';

import { CarouselCars } from '../../components/carousel-cars';
import { CarouselTitle } from '../../components/carousel-title';
import { onVWBasicPageLoad } from '../../tagging/tagging-helpers';
import { StyledModelsCarouselWrapper } from './styles';
import { useSharedConfigs } from '../../context/shared-configs-context';
import { useTrackingManager } from '../../hooks/use-tracking-manager';
import { DisclaimerProcessor } from '../../components/disclaimer-processor/DisclaimerProcessor';

export const ModelsCarousel = () => {
  const { disclaimers } = useSharedConfigs();
  const trackingManager = useTrackingManager();

  const initialDisclaimerData: ModalDisclaimer = {
    active: false,
  };

  useEffect(() => {
    onVWBasicPageLoad(trackingManager);
  }, []);

  return (
    <DisclaimerProcessor disclaimers={disclaimers}>
      <ModalDisclaimersService disclaimerData={initialDisclaimerData}>
        <StyledModelsCarouselWrapper id="modelsCarouselFA">
          <CarouselTitle />
          <CarouselCars />
        </StyledModelsCarouselWrapper>
      </ModalDisclaimersService>
    </DisclaimerProcessor>
  );
};
